import { pageTitle } from "ember-page-title";
<template>
  {{pageTitle "EmberBeats"}}
  {{outlet}}
</template>
